import { Predicates } from "../libraries/predicates/predicates";
import { IPlugType } from "../types/data.interface";

export const formatPlugTypeIntoOption = (
  item: IPlugType | null,
) => {
  return Predicates.isNotNullAndNotUndefined(item)
    ? {
        value: item,
        label: `${item.name}`,
      }
    : null;
};

export const getPlugTypes = (
  plugTypes: IPlugType[],
) =>
  plugTypes
    .map(formatPlugTypeIntoOption)
    .filter(Predicates.isNotNullAndNotUndefined)
    .sort((a, b) => {
      if (a.value.id === 0) return -1;
      if (b.value.id === 0) return 1;
      return 0;
    });
